import { useEffect, useState } from "react";
import { useCreateApiCall } from "./useCreateApiCall";
import { useAppDispatch } from "store/hooks";
import { API } from "aws-amplify";
import { showError } from "store/reducers/errorReducer";

export const useButtonLocationBySuperAdmin = ({ buttonId }) => {
  const dispatch = useAppDispatch();
  const [buttonLocation, setButtonLocation] = useState(null);
  const [hardButton, setHardButton] = useState(undefined);
  const [senders, setSenders] = useState([]);
  const [providers, setProviders] = useState([]);
  const [selectedSpecialists, setSelectedSpecialists] = useState([]);
  const { createApiCall } = useCreateApiCall();


  const [isButtonLocationLoading, setIsButtonLocationLoading] = useState(true);

  useEffect(() => {
    const loadData = createApiCall(async () => {
      const result = await API.get(
        "restApi",
        `/button_locations/${buttonId}`,
        {}
      );

      if (result?.error) {
        dispatch(showError(result.error));
        setIsButtonLocationLoading(false);
        return;
      }

      const buttonLocation = result?.Item ?? {};
      setButtonLocation(buttonLocation);
      setHardButton(result?.hardButton);
      const senders = result?.senders ?? [];
      const selectedSenders = result?.selectedSenders ?? [];
      setSenders(
        senders.filter(({ id }) => selectedSenders?.includes(id))
      );
      const providers = result?.providers ?? [];
      const selectedProviders = result?.selectedProviders ?? [];
      setProviders(
        providers.filter(({ id }) => selectedProviders?.includes(id))
      );

      setSelectedSpecialists(result?.specialists ?? []);

      setIsButtonLocationLoading(false);
    });

    loadData();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [buttonId]);

  return {
    buttonLocation,
    hardButton,
    setHardButton,
    senders,
    providers,
    isButtonLocationLoading,
    selectedSpecialists,
  };
};
